const genders = require('../data/genders.json')
module.exports = genders
